import { compose } from "redux";
import { withDailyTextsData } from "../../store/dailytexts";

export default compose(withDailyTextsData);



// WEBPACK FOOTER //
// ./src/components/TimeSelect/connector.js